import {  createReducer } from "@reduxjs/toolkit";
import types from './actionTypes';

const initialState = {
    ranges:[],
    directBonds:[],
    directBondsMemberships: [],
    prizes:[],

}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.getRanges, (state, action) => {
      state.ranges = action.payload;
    })      

    .addCase(types.getDirectBonds, (state, action) => {
      state.directBonds = action.payload;
    })      

    .addCase(types.getPrizes, (state, action) => {
      state.prizes = action.payload;
    })  

    .addCase(types.getDirectBondsMemberships, (state, action) => {
      state.directBondsMemberships = action.payload;
    })  
});